export default import.meta.ROLLDOWN_FILE_URL_e8xLHJLH0Wlaqe4ABb0SXg